import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Tag,
  Modal,
  Typography,
  Statistic,
  Divider,
  Pagination,
  Tooltip,
  Spin,
  Input,
} from "antd";
import {
  ShoppingCartOutlined,
  CheckCircleOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { Container, ViewInput } from "./styles";
import { HeaderTitle, Message } from "../../../GlobalStyles";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { getValue } from "../../../services/functions";
import CountUp from "react-countup";

const { Title, Text, Paragraph } = Typography;

const ComprarLead = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [balance, setBalance] = useState(0);
  const [bonus, setBonus] = useState(0);
  const [page, setPage] = useState(0);
  const [leads, setLeads] = useState([]);
  const [location, setLocation] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [leadsTotal, setLeadsTotal] = useState(0);

  useEffect(() => {
    listLeads(page, locationSearch);
    window.scrollTo(0, 0);
  }, [page, locationSearch]);

  async function listLeads(page, locationSearch) {
    setIsLoading(true);
    await api
      .get(
        `/leads-buy?page=${page}${
          locationSearch ? `&location=${locationSearch}` : ""
        }`
      )
      .then((response) => {
        setLeads(response.data.leads);
        setLeadsTotal(response.data.leadsTotal);
        setBalance(response.data.balance);
        setBonus(response.data.bonus);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  const handleResgatarClick = (lead) => {
    setSelectedLead(lead);
    setIsModalVisible(true);
  };

  async function buyLead() {
    setIsLoadingModal(true);
    await api
      .put(`/buy-lead/${selectedLead.id}`)
      .then((response) => {
        listLeads();
        setIsModalVisible(false);
        toast.success(
          `Lead resgatado com sucesso, já está disponivel no seu CRM e carteira de leads.`
        );
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(true);
  }

  return (
    <Container>
      <HeaderTitle style={{ marginBottom: 0 }}>
        <h1>Área de Marketing</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            navigate("/clientes/adicionar-saldo");
          }}
        >
          <MdAdd size="20" color="#fff" />
          <span>Adicionar Saldo</span>
        </Button>
      </HeaderTitle>

      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <p>Saldo disponível:</p>
          <h3>
            <CountUp
              duration={1.5}
              end={balance}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
            />
            {!!bonus && (
              <span style={{ fontSize: 18 }}>
                <CountUp
                  duration={1.5}
                  end={bonus}
                  prefix="  + R$ "
                  separator="."
                  decimal=","
                  decimals={2}
                />
              </span>
            )}
            <span style={{ fontSize: 13 }}>
              {!!bonus && `  para comprar de leads`}
            </span>
          </h3>
          <ViewInput style={{ width: 300, marginBottom: 15 }}>
            <p>Pesquisar por Cidade</p>
            <Input.Search
              value={location}
              onChange={(text) => {
                setLocation(text.target.value);
              }}
              placeholder="localização"
              onSearch={(text) => {
                setLocationSearch(text);
                if (page) {
                  setPage(0);
                } else {
                  listLeads(0, text);
                }
              }}
              allowClear
              onClear={() => {
                setLocationSearch("");
                if (page) {
                  setPage(0);
                }
                setLocation("");
              }}
              enterButton
            />
          </ViewInput>

          {leadsTotal ? (
            <Paragraph>
              Abaixo estão os leads disponíveis para resgate.
            </Paragraph>
          ) : (
            <Message>Nenhum disponivel no momento</Message>
          )}
          <Row
            gutter={[24, 24]}
            style={{
              marginTop: 20,
            }}
          >
            {leads.map((lead) => (
              <Col xs={24} sm={12} md={8} key={lead.id}>
                <Card
                  hoverable
                  title={lead.name}
                  extra={
                    <Tooltip title={lead.location}>
                      <Tag color="blue" style={{ marginLeft: 15 }}>
                        <EnvironmentOutlined />{" "}
                        {lead.location.length > 25
                          ? lead.location.slice(0, 15) + "..."
                          : lead.location}
                      </Tag>
                    </Tooltip>
                  }
                >
                  <Paragraph ellipsis={{ rows: 3, expandable: false }}>
                    {lead.necessity}
                  </Paragraph>
                  <Paragraph ellipsis={{ rows: 3, expandable: false }}>
                    {lead.email}
                  </Paragraph>
                  <Paragraph ellipsis={{ rows: 3, expandable: false }}>
                    {lead.phone_number}
                  </Paragraph>
                  <Divider />
                  <Row justify="space-between" align="middle">
                    <Col>
                      <Text strong style={{ fontSize: 18 }}>
                        {getValue(lead.price || 0)}
                      </Text>
                    </Col>
                    <Col>
                      <Button
                        type="primary"
                        icon={<ShoppingCartOutlined />}
                        onClick={() => handleResgatarClick(lead)}
                        disabled={balance < lead.price}
                      >
                        Resgatar
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>

          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={leadsTotal}
            pageSize={30}
            showTotal={(total) => `${total} leads`}
          />
        </>
      )}

      {selectedLead && (
        <Modal
          title="Confirmar Resgate de Lead"
          open={isModalVisible}
          isLoading={isLoadingModal}
          onOk={() => {
            buyLead();
          }}
          onCancel={() => {
            setIsModalVisible(false);
          }}
          okText="Confirmar Resgate"
          cancelText="Cancelar"
        >
          <Paragraph>Você está prestes a resgatar o seguinte lead:</Paragraph>
          <Card
            title={selectedLead.name}
            extra={
              <Tooltip title={selectedLead.location}>
                <Tag color="blue" style={{ marginLeft: 15 }}>
                  <EnvironmentOutlined />{" "}
                  {selectedLead.location.length > 25
                    ? selectedLead.location.slice(0, 15) + "..."
                    : selectedLead.location}
                </Tag>
              </Tooltip>
            }
          >
            <Paragraph ellipsis={{ rows: 3, expandable: false }}>
              {selectedLead.necessity}
            </Paragraph>
            <Paragraph ellipsis={{ rows: 3, expandable: false }}>
              {selectedLead.email}
            </Paragraph>
            <Paragraph ellipsis={{ rows: 3, expandable: false }}>
              {selectedLead.phone_number}
            </Paragraph>
            <Divider />
            <Row justify="space-between">
              <Col>
                <Text>Custo:</Text>
              </Col>
              <Col>
                <Tag color="red" style={{ marginBottom: 5 }}>
                  {" "}
                  {getValue(selectedLead.price || 0)}
                </Tag>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col>
                <Text>Seu saldo atual:</Text>
              </Col>
              <Col>
                <Tag color="green" style={{ marginBottom: 5 }}>
                  {" "}
                  {getValue(balance || 0)}
                </Tag>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col>
                <Text strong>Novo Saldo:</Text>
              </Col>
              <Col>
                <Tag color="blue" style={{ marginBottom: 5 }}>
                  {getValue(balance - selectedLead.price || 0)}
                </Tag>
              </Col>
            </Row>
          </Card>
          <Paragraph style={{ marginTop: 16 }}>Deseja continuar?</Paragraph>
        </Modal>
      )}
    </Container>
  );
};

export default ComprarLead;
